<template>
  <div class="charts">
    <div v-for="data in datas" v-bind:key="data.id">
      <Panel :data="data" :mode="mode"/>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Panel from '@/components/Panel.vue'

export default {
  name: 'Dashboard',
  components: {
    Panel
  },
  data() {
    return {
      datas:[
        {id: 0, title: "Kotłownia 77D"},
        {id: 8, title: "Kotłownia 78"},
        {id: 1, title: "Kotłownia 79"},
        {id: 7, title: "Kotłownia 84"},
        {id: 6, title: "Kotłownia 91"},
        {id: 2, title: "Kotłownia 91A"},
        {id: 3, title: "Kotłownia 91B"},
        {id: 4, title: "Kotłownia 91C"},
        {id: 5, title: "Kotłownia 91D"},
      ],
      mode: "charts"
      
    }
  },
  
}
</script>